<div class="page-content-wrapper">
  <div v-if="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div v-else>
    <!-- Analytical Data Cards - Always Visible -->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <icon-card
          :count="analytical_data ? analytical_data.total_services : 0"
          title="Services"
          icon_class="bi bi-people"
        />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <icon-card
          :count="analytical_data ? analytical_data.total_logs : 0"
          title="Logs"
          icon_class="bi bi-journal-text"
        />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <icon-card
          :count="analytical_data ? Math.round(analytical_data.success_rate) + '%' : '0%'"
          title="Success Rate"
          icon_class="bi bi-check2-circle" 
        />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <icon-card
          :count="analytical_data ? Math.round(analytical_data.average_requests_per_month) : 0"
          title="Avg usage / month"
          icon_class="bi bi-calendar3"
        />
      </div>
    </div>

    <!-- Top 5 Services and Graph - Always Visible -->
    <div class="row mt-3">
      <div class="d-none d-md-block col-md-4">
        <div class="card shadow border rounded-3 h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="fs-7 mb-0 fw-bold text-dark"
                >Top 5 Services Success Rate</label
              >
              <small class="text-muted text-xs">Last 30 days</small>
            </div>

            <div class="progress-services-container p-2">
              <div
                v-for="(service, index) in top_services"
                :key="index"
                class="service-progress-item mb-2"
              >
                <div
                  class="service-header d-flex justify-content-between align-items-center mb-2"
                >
                  <div class="service-info">
                    <span class="service-name fw-medium text-sm text-dark"
                      >{{ service.service_name }}</span
                    >
                    <div class="service-stats text-muted text-xs">
                      {{ service.successful_requests }}/{{
                      service.total_requests }} requests
                    </div>
                  </div>
                  <div class="success-rate-badge">
                    <span
                      class="badge rounded-pill fw-medium"
                      :style="{
                          backgroundColor: get_badge_color(service.success_rate),
                          color: 'white'
                        }"
                    >
                      {{ Math.round(service.success_rate) }}%
                    </span>
                  </div>
                </div>

                <div class="progress-wrapper">
                  <ProgressBarComponent
                    :percentage="service.success_rate"
                    :color="get_progress_bar_color(service.success_rate)"
                    size="md"
                    :show_label="false"
                    :animated="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-md-block col-md-8">
        <div class="card shadow border rounded-3">
          <div class="card-body log-graphs"></div>
        </div>
      </div>
    </div>

    <!-- Sliding Tabs -->
    <div class="row mt-4">
      <div class="col-12">
        <SlideTabComponent
          :tabs="tabs"
          :modelValue="active_tab"
          @update:modelValue="active_tab = $event"
          @tab-changed="on_tab_changed"
        />
      </div>
    </div>

    <!-- Tab Content -->
    <div v-if="active_tab === 'logs'">
      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="card shadow rounded-3 p-0">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="row g-2 form-group">
                    <div class="col-md-3 col-sm-12">
                      <label class="form-label text-xxs">From Date</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="filters.start_date"
                      />
                    </div>
                    <div class="col-md-3 col-sm-12">
                      <label class="form-label text-xxs">To Date</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="filters.end_date"
                      />
                    </div>
                    <div class="col-md-3 col-sm-12">
                      <label class="form-label text-xxs">Service</label>
                      <select
                        class="form-select form-control"
                        v-model="filters.service_id"
                      >
                        <option class="text-xs" hidden>
                          Filter by Service
                        </option>
                        <option value="">All Services</option>
                        <option
                          v-for="service_name in services_list"
                          :key="service_name"
                          :value="service_id_map[service_name]"
                        >
                          {{ service_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 col-sm-12">
                      <label class="form-label text-xxs">Status</label>
                      <select
                        class="form-select form-control"
                        v-model="filters.verification_status"
                      >
                        <option class="text-xs" hidden>Filter by Status</option>
                        <option value="">All Statuses</option>
                        <option
                          v-for="status in status_options"
                          :key="status"
                          :value="status"
                        >
                          {{ status }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="d-flex justify-content-end">
                    <div>
                      <button
                        class="btn btn-bg-green text-xs btn-sm rounded-3 me-2"
                        @click="apply_filters"
                        type="button"
                      >
                        Apply Filters
                      </button>
                      <button
                        class="btn btn-bg-secondary text-xs btn-sm rounded-3"
                        @click="reset_filters"
                        type="button"
                      >
                        Reset Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mt-2">
        <div class="card shadow rounded-3 p-0">
          <div class="card-body">
            <CustomTable
              ref="logsTable"
              :columns="columns"
              :fetchData="get_logs"
              :hasActions="false"
              :showSearch="false"
              tableKey="service_logs"
            >
              <template v-slot:cell-service_name="{ row }">
                <span class="text-xxs">{{ row.service_name }}</span>
              </template>
              <template v-slot:cell-date_created="{ row }">
                <span class="text-xxs"
                  >{{ format_date(row.date_created) }}</span
                >
              </template>
              <template v-slot:cell-verification_status="{ row }">
                <span class="text-xxs">{{ row.verification_status }}</span>
              </template>
              <template v-slot:cell-api_result_status="{ row }">
                <span class="text-xxs">{{ row.api_result_status }}</span>
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>

    <!-- Service Response Tab -->
    <div v-if="active_tab === 'responses'">
      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="card shadow rounded-3 p-0">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="row g-2 form-group">
                    <div class="col-md-3 col-sm-12">
                      <label class="form-label text-xxs">From Date</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="response_filters.start_date"
                      />
                    </div>
                    <div class="col-md-3 col-sm-12">
                      <label class="form-label text-xxs">To Date</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="response_filters.end_date"
                      />
                    </div>
                    <div class="col-md-3 col-sm-12">
                      <label class="form-label text-xxs">Service</label>
                      <select
                        class="form-select form-control"
                        v-model="response_filters.service_id"
                      >
                        <option class="text-xs" hidden>
                          Filter by Service
                        </option>
                        <option value="">All Services</option>
                        <option
                          v-for="service_name in response_services_list"
                          :key="service_name"
                          :value="response_service_id_map[service_name]"
                        >
                          {{ service_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="d-flex justify-content-end">
                    <div>
                      <button
                        class="btn btn-bg-green text-xs btn-sm rounded-3 me-2"
                        @click="apply_response_filters"
                        type="button"
                      >
                        Apply Filters
                      </button>
                      <button
                        class="btn btn-bg-secondary text-xs btn-sm rounded-3"
                        @click="reset_response_filters"
                        type="button"
                      >
                        Reset Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mt-2">
        <div class="card shadow rounded-3">
          <div class="card-body">
            <!-- Response Cards -->
            <div
              class="accordion mb-2"
              id="responses-accordion"
              v-if="api_responses.length > 0"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(response, index) in api_responses"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  v-if="response.response"
                  :class="{ 'border-none border-bottom rounded-3': !is_response_accordion_open(index) }"
                  :id="'response-heading-' + index"
                  @click="toggle_response_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(response) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_response_accordion_open(index), 'fas fa-chevron-up': is_response_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  v-if="response.response"
                  :id="'response-collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'response-heading-' + index"
                  data-parent="#responses-accordion"
                >
                  <div class="card-body mb-3">
                    <!-- Report Components based on service type -->
                    <div class="response-content">
                      <!-- Trust Search Response -->
                      <template
                        v-if="response.service_name?.toLowerCase().includes('trust search')"
                      >
                        <TrustSearchReport
                          :trust_search_data="get_result_data(response)"
                          :sheet_elements="`#response-collapse-${index} .sheet`"
                        />
                      </template>

                      <!-- Enterprise AML Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('enterprise anti money laundering')"
                      >
                        <ReportViewer
                          :response_doc="response.response_doc"
                          title="Enterprise Anti-Money Laundering Report"
                          service_type="enterprise_aml"
                          :export_data="response.response"
                        >
                          <EnterpriseAmlVerificationReport
                            :aml_data="get_result_data(response)"
                            :response_info="response_info_aml(response)"
                            :sheet_elements="`#response-collapse-${index} .sheet`"
                          />
                        </ReportViewer>
                      </template>

                      <!-- Regular AML Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('anti money laundering')"
                      >
                        <ReportViewer
                          :response_doc="response.response_doc"
                          title="Anti-Money Laundering Report"
                          service_type="aml"
                          :export_data="response.response"
                        >
                          <AMLReport
                            :aml_data="aml_results(response)"
                            :response_info="response_info_aml(response)"
                            :sheet_elements="`#response-collapse-${index} .sheet`"
                            :date_scored="date_scored(response)"
                          />
                        </ReportViewer>
                      </template>

                      <!-- Enterprise Credit Check Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('enterprise credit check')"
                      >
                        <ReportViewer
                          :response_doc="response.response_doc"
                          title="Enterprise Credit Check Report"
                          service_type="enterprise_credit"
                          :export_data="response.response"
                        >
                          <CompanyCreditReport
                            :customer_credit_data="get_result_data(response)"
                            :sheet_elements="`#response-collapse-${index} .sheet`"
                          />
                        </ReportViewer>
                      </template>

                      <!-- RSA ID Verification Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('rsa id verification')"
                      >
                        <ReportViewer
                          :response_doc="response.response_doc"
                          title="RSA ID Verification Report"
                          service_type="rsa_id_verification"
                          :export_data="response.response"
                        >
                          <RsaIdVerificationReport
                            :rsa_id_data="get_result_data(response)"
                            :sheet_elements="`#response-collapse-${index} .sheet`"
                          />
                        </ReportViewer>
                      </template>

                      <!-- Refugee Verification Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('refugee verification')"
                      >
                        <RefugeeVerificationReport
                          :refugee_verification_data="get_result_data(response)"
                          :sheet_elements="`#response-collapse-${index} .sheet`"
                        />
                      </template>

                      <!-- Individual Bank Account Verification Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('bank account individual verification')"
                      >
                        <IndividualBankAccountReport
                          :bank_account_data="get_result_data(response)"
                          :sheet_elements="`#response-collapse-${index} .sheet`"
                        />
                      </template>

                      <!-- Company Bank Account Verification Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('bank account company verification')"
                      >
                        <CompanyBankAccountReport
                          :company_account_data="get_result_data(response)"
                          :sheet_elements="`#response-collapse-${index} .sheet`"
                        />
                      </template>

                      <!-- CIPC Verification Response -->
                      <template
                        v-else-if="response.service_name?.toLowerCase().includes('cipc verification')"
                      >
                        <CIPCReport
                          :cipc_data="get_result_data(response)"
                          :sheet_elements="`#response-collapse-${index} .sheet`"
                        />
                      </template>

                      <!-- Default response (table format for other services) -->
                      <template v-else>
                        <div v-if="response.processed_response">
                          <div class="row">
                            <div class="col-12">
                              <div class="table-responsive">
                                <table class="table table-striped table-sm">
                                  <thead>
                                    <tr>
                                      <th class="text-xs">Field</th>
                                      <th class="text-xs">Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="item in response.processed_response"
                                      :key="item.key"
                                    >
                                      <td class="text-xs fw-bold">
                                        {{ item.label }}
                                      </td>
                                      <td class="text-xs">{{ item.value }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <pre class="bg-light p-3 rounded text-xs">
{{ format_response(response.response) }}</pre
                          >
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- No Results Message -->
            <div v-else>
              <div class="card bg-white border rounded-3 text-center py-4">
                <div class="card-body">
                  <i class="bi bi-info-circle text-muted mb-3 fs-3"></i>
                  <h6 class="text-muted mb-2">No API Responses Found</h6>
                  <p class="text-muted small mb-0">
                    There are no API responses available for the selected
                    filters.
                  </p>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <div
              class="d-flex justify-content-between align-items-center mt-2"
              v-if="responses_total_pages > 1"
            >
              <span class="text-xs text-muted">
                Page {{ responses_current_page }} of {{ responses_total_pages }}
              </span>
              <div>
                <button
                  class="btn btn-sm btn-bg-secondary rounded-3 text-xs me-2"
                  @click="responses_previous_page"
                  :disabled="responses_current_page === 1"
                >
                  Previous
                </button>
                <button
                  class="btn btn-sm btn-bg-secondary rounded-3 text-xs"
                  @click="responses_next_page"
                  :disabled="responses_current_page === responses_total_pages"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
